<style lang="scss" scoped>
@import '../../../sass/utilities/variables';

.job-container {
  padding: 3rem;
  border: 1px solid $light-silver;
  margin-top: 3rem;
  border-radius: 2rem;
  display: block;
}

.employer-title {
  font-weight: bold;
  font-style: normal;
  font-size: 2rem;
  color: $dark-grey;
}

.job-details {
  font-weight: bold;
  font-style: normal;
  font-size: 1.4rem;
  color: $dark-grey;
  padding-top: 2rem;
}
</style>
<template>
  <a
    :href="data.careers_page_url"
    class="job-container"
  >
    <div class="employer-title">{{ data.employer_name }}</div>
    <div class="job-details">{{ jobsAvailable }}</div>
  </a>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    jobsAvailable() {
      return `${this.data.jobs_count} Jobs Available`;
    },
  },
};
</script>
